import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import InfoTip from './InfoTip';

// The labelled row and the chip row the Registry forms are built from. Shared so the switch builder
// looks the same wherever it is opened from.

export const Field = ({ label, tip, hint, full = false, optional = false, action = null, children }) => (
  <div className={cn('field', { full })}>
    <div className='label-row'>
      <label>
        {label}
        {optional ? ' (optional)' : ''}
        {tip && <InfoTip message={tip} />}
      </label>
      {action}
    </div>
    {children}
    {hint && <div className='hint'>{hint}</div>}
  </div>
);

Field.propTypes = {
  label: PropTypes.string.isRequired,
  tip: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  hint: PropTypes.string,
  full: PropTypes.bool,
  optional: PropTypes.bool,
  action: PropTypes.node,
  children: PropTypes.node
};

export const Chips = ({ values, selected, labels, onToggle }) => (
  <div className='chips'>
    {values.map(value => (
      <button key={value} type='button' className={cn('chip', { on: selected.includes(value) })} onClick={() => onToggle(value)}>
        {labels[value] || value}
      </button>
    ))}
  </div>
);

Chips.propTypes = {
  values: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  labels: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired
};
